import { render, staticRenderFns } from "./safetyHealthyMstCopy.vue?vue&type=template&id=b06baa80"
import script from "./safetyHealthyMstCopy.vue?vue&type=script&lang=js"
export * from "./safetyHealthyMstCopy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b06baa80')) {
      api.createRecord('b06baa80', component.options)
    } else {
      api.reload('b06baa80', component.options)
    }
    module.hot.accept("./safetyHealthyMstCopy.vue?vue&type=template&id=b06baa80", function () {
      api.rerender('b06baa80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/sht/safetyHealthyMstCopy.vue"
export default component.exports